export function setClientes(state, clientes) {
    state.clientes = clientes;
}

export function setClienteSelec(state, cliente) {
    state.clienteSelec = cliente;
}

export function actListClientes(state, cliente) {
    if (cliente !== null) {
        const index = state.clientes.findIndex(r => r.id === cliente.id)
        if (index != -1) {
            state.clientes[index].nombre = cliente.nombre;  
            state.clientes[index].telefono = cliente.telefono;  
            state.clientes[index].email = cliente.email;  
            state.clientes[index].dni = cliente.dni;  
            state.clientes[index].domicilio = cliente.domicilio;  
            state.clientes[index].agencia = cliente.agencia;
            state.clientes[index].observaciones = cliente.observaciones;  
        }
    }
  
}

export function actDeleteListClientes(state, id) {
    if (id != null) {
        const index = state.clientes.findIndex(r => r.id === id)
        if (index != -1) {
            state.clientes.splice(index, 1)
        }
    }
}


